export default "__VITE_ASSET__6f574490__"